import React from "react";
import ReactDOM from "react-dom";
import { useHistory } from "react-router";
import Styles from "./Popup.module.css";
import { CircularProgress } from "@material-ui/core";

function Popup(props) {
  var [loading, setLoading] = React.useState(false);
  React.useEffect(() => {
    // setTimeout(()=>{
    //   setLoading(false);
    // }, 750)
  }, []);
  var history = useHistory();

  return props.show ? (
    <div className={Styles.Popup}>
      <div className={Styles.InnerPopup}>
        <div
          className={Styles.PopUpClose}
          onClick={() => {
            history.goBack();
          }}
        >
          <span class="material-icons">close</span>
        </div>

        {props.children}
      </div>
    </div>
  ) : (
    ""
  );
}

export default Popup;
